export default {
    "accountValidateMsg" : "Account must contain 6 - 30 characters, including letters, digits and symbols (\".\", \"_\", \"@\"). The first character must be digit or letter.",
    "storeSuccess" : "Recharge Success",
    "editAccountTips" : "Please enter a valid account name",
    "editPwdTips" : "Please enter a valid password",
    "editRepeatPwdTips" : "Please enter your password again",
    "pwdRepeatTips" : "Passwords do not match",
    "changePwdSucc" : "Your password has been changed",
    "bindEmail" : "Bind Email",
    "errorVrifyCodeTips" : "verification code error",
    "slectQuessionTips" : "Please select a security question?",
    "answerTips" : "Please enter the answer",
    "twoAnswerTips" : "Please select created security questions and enter the correct answers",
    "realNameValidateTips" : "Real name (4 to 60 characters)",
    "phoneValidateTips" : "Phone Number(6 to 18 digits)",
    "areaSelectTips" : "Please select region",
    "iDCardValidataTips" : "ID Number(1 to 60 digits)",
    "changeProfileSucc" : "Updated info saved",
    "editVrfCodeTips" : "Please enter verify code",
    "securityQuestionTips" : "Please create security questions to improve your account security. When you forget your password, you can answer the questions to reset the password.",
    "validateQuessionTips" : "Please select two different questions and verify. You can recreate the questions after the verification.",
    "originPwd" : "Original password",
    "newPwd" : "New password",
    "changePwdSuccess" : "Password changed. We suggest you log in again right now to save your progress.",
    "accountName" : "Account name",
    "password" : "Please enter your password",
    "repeatPassword" : "Please repeat your password",
    "findPwdTips" : "Please enter the account that you want to retrieve the password from",
    "submit" : "submit",
    "send" : "Send",
    "modify" : "modify",
    "haveAgree" : "Agree",
    "and" : "and",
    "privacyPolicy" : "Privacy Policy",
    "completeness" : "Completion",
    "gender" : "Gender",
    "male" : "male",
    "female" : "female",
    "birthday" : "Birthday",
    "phone" : "Phone",
    "region" : "Region",
    "ID" : "ID",
    "accountSetting" : "Account Settings",
    "upgrade" : "Upgrade",
    "profile" : "Profile",
    "changePassword" : "Change Password",
    "securityQuestion" : "Security Questions",
    "creatework_headerTitle" : "Create Ticket",
    "mylist_headerTitle" : "My Ticket",
    "bindEmailTips" : "Verify your e-mail for your account\'s security. If you forgot your password, we will send you an email to this e-mail address.",
    "enterEmailVrfcationTips" : "Please enter the verification code here.",
    "cancel" : "CANCEL",
    "bindTps" : "Bind your account to play the game on multiple devices!",
    "login" : "Log in",
    "logout" : "log out",
    "bind" : "Bind Account",
    "feedback" : "Feedback",
    "terms" : "Agreements",
    "tips" : "Notice",
    "debindTips" : "Unbinding may result in data loss. Are you sure you want to unbind?",
    "debindText" : "Unbind",
    "guestSwitchTips" : "Guest account detected. After the login, your guest account data will be lost. Continue?",
    "register" : "sign up",
    "realName" : "realName",
    "enterEmailTips" : "Please enter your email address",
    "emailVAlidateMsg" : "invalid email",
    "editEmaileTips" : "Please enter your email address",
    "checkServiceTips" : "Please read Terms of Use and Privacy Policy first.",
    "brithdayValidateTips" : "Enter your birthday",
    "facebookValidateTips" : "Facebook Account (1 to 60 characters)",
    "eritOriginPwdTips" : "Original password",
    "submitSuccess" : "Submitted",
    "rebindEmail" : "Change Bound E-mail",
    "bindEmailSuccess" : "Email bound: \$email</br>Please use a bound e-mail to verify. You may reset your e-mail after verification.",
    "reSetSecurityQuessoon" : "You have successfully created the security questions </br></br>Please select different questions and verify. You can recreate the questions after the verification.",
    "canotModifyTips" : "Changes are NOT allowed upon submission, sure to submit?",
    "rebindEmailTips" : "Your e-mail is :\$email,please tap here to get verification code",
    "reGetVrfCode" : "Get Code",
    "findPwdWayTips" : "Please select one of the following ways",
    "emailWay" : "Retrieve by security email",
    "emailWayTips" : "You will receive a confirmation email and then you can reset the password",
    "quessionWay" : "Retrieve by security questions",
    "quessionWayTips" : "Answer the created security questions and then reset the password",
    "resetPwdBtn" : "Reset the password",
    "lastStep" : "Previous",
    "sendEmailTips" : "We have sent you an email to \$email.<br>Please enter the verification code you received here.",
    "setNewPwdTips" : "Congratulations!<br>User identity verified. Now you can reset your password.",
    "termsOfUse" : "Terms of Use",
    "copy_success" : "Copied",
    "creatework_create" : "Ticket",
    "creatework_createHolder" : "Select Type",
    "creatework_title" : "Subject",
    "creatework_titleHolder" : "Please enter a subject",
    "creatework_detail" : "details",
    "creatework_detailHolder" : "Description must not contain more than 200 characters",
    "creatework_uploadTips" : "Please upload jpg/png files only. Uploaded file must be smaller than 5 MB.",
    "creatework_selectBox_selectTile" : "Type",
    "creatework_goGame" : "Return",
    "creatework_history" : "History",
    "mylist_noYet" : "No record",
    "mywork_solved" : "Problem solved?",
    "mywork_service" : "Rate us",
    "mywork_messageHolder" : "New message",
    "mywork_score" : "Score",
    "mywork_confirm" : "CONFIRM",
    "creatework_selectBox_selectList3" : "Other",
    "creatework_selectBox_selectList2" : "Account",
    "close" : "Close",
    "creatework_gameHolder" : "Select Game",
    "creatework_serverHolder" : "Select server",
    "contactService" : "Contact CS",
    "FAQ" : "FAQ",
    "creatework_game" : "Game:",
    "creatework_server" : "Server:",
    "creatework_role" : "Character:",
    "selectRoleName" : "Select Character",
    "creatework_noRole" : "No character",
    "creatework_noGame" : "Game list is empty",
    "creatework_noServer" : "Server list is empty",
    "termText" : "I agree to {mainHost}",
    "backLogin" : "DECLINE",
    "creatework_roleHolder" : "Access after choosing your character",
    "findPwdFailTips" : "You have not set security questions. Please contact customer service.",
    "payMall" : "Mall",
    "selectPayment" : "amount",
    "plzSelectPayWay" : "select channel",
    "gainPlus" : "Bonus",
    "gainMorePlus" : "Add More",
    "gainMostPlus" : "Max",
    "plzSelectPayType" : "Select Payment Method",
    "roleName" : "Character",
    "payWay" : "Payment Channel",
    "plzSelectOtherWay" : "Alternative Payment Channel",
    "payment" : "Amount",
    "compensateTips" : "Surplus will be returned to you in \$gameCode",
    "extaGain" : "Bonus",
    "gameGold" : "In-game Currency",
    "compensate" : "Compensation",
    "payWayPlus" : "Channel Bonus",
    "neddPay" : "Payment",
    "submitOrder" : "Submit",
    "screenshotTips" : "Notice: take a screenshot of your order in case of a transaction error.",
    "storeFail" : "Failed to recharge",
    "storeFailTips" : "Transaction failed. Please submit order again or contact our customer service.",
    "storeAcceptance" : "Processing",
    "storeSuccessTips" : "Transaction shall be done in 15 mins.",
    "orderNumber" : "Order No.",
    "buyProduct" : "Recharge Item",
    "transactionAmount" : "Amount",
    "failReason" : "Reason",
    "payOntherORder" : "New order",
    "reStore" : "Recharge Again",
    "confirm" : "Confirm",
    "switch" : "Switch Account",
    "completeTips" : "Please fill in your personal information. <mark class=\"yellowMarkColor\">Information will not be editable again</mark>. When you are trying to retrieve a lost account, you will be asked to provide correct personal information.",
    "creatework_selectBox_selectList0" : "Game Error",
    "creatework_selectBox_selectList1" : "Payment Error",
    "creatework_selectBox_selectList4" : "Translation Error",
    "mywork_solvedText" : "Problem solved",
    "browserPayErrBtnText" : "Payment Error",
    "browserPaySucBtnText" : "Payment completed",
    "browserPayingTips" : "Redirecting to third-party platform.<br/>Can close this page after payment.",
    "price_list_empty" : "No applicable sum",
    "pointCardTips" : "Note: This item only supports \$paymentAmount card",
    "forgetPwd" : "Forgot your password?",
    "payCenter" : "Recharge Center",
    "willGet" : "You will get",
    "goods" : "item",
    "discount" : "Bonus",
    "payDiscount" : "Compensation",
    "payDiscountTips" : "Extra points will be converted to Diamonds",
    "hasQuestionPlease" : "If you have any questions, please",
    "pwdValidateMsg" : "Password must contain 6 to 20 characters",
    "payWayPlusC" : "Channel Bonus",
    "fwtk" : "TERMS OF SERVICE",
    "yszc" : "PRIVACY POLICY",
    "exchange" : "Gift code exchange",
    "remember" : "remember my choice",
    "thirdInfo" : "About Account",
    "thirdInfoContent" : "Please bind your account in the in-game User Center. After that, log in the game using the bound account.",
    "unLink" : "This method is currently not supported",
    "favour" : "Bookmark",
    "goStoreTip" : "Please proceed to the payment page",
    "go" : "Go",
    "otherLogin" : "Other login methods",
    "qrCodeTip" : "Scan the QR code to get started!",
    "favourTip" : "Bookmark the page to play again later!",
    "share" : "Share",
    "landscapeTip" : "Please proceed in portrait mode",
    "leaveTip" : "Exit the game?",
    "selectRole" : "Please choose character",
    "selectMoney" : "Please choose prop",
    "seletGameInfoFirst" : "Please choose game",
    "lowerIE" : "IE version too old",
    "linkTermText" : "I have accepted {mainHost} [Terms of Use] and [Privacy Policy]",
    "download" : "Download",
    "favourAndDownloadTip" : "Bookmark this page to browser or download on PC",
    "payReward" : "Recharge Reward",
    "hasEqualReward" : "Double bonus for both payment methods",
    "payBtnText" : "Payment",
    "storeHoaveReward" : "Recharge Bonus",
    "showMorePayWay" : "More Methods",
    "needPaymentCount" : "Amount",
    "orderDetail" : "Details",
    "selectPayWayPlz" : "Choose payment",
    "countryCode" : "Country code",
    "deleteaccount_title1" : "Delete Account",
    "deleteaccount_title2" : "Request account deletion",
    "deleteaccount_step1_1" : "Your account will be frozen for 14 days since the account deletion. After 14 days, your account will be permanently deleted. You will not be able to log in with other social accounts.",
    "deleteaccount_step1_2" : "You may revoke the deletion within the 14 days through the link below:",
    "deleteaccount_step1_3" : "Once deleted, you will not be able to restore your account information. You will not be compensated for any loss caused by account deletion.",
    "deleteaccount_step1_4" : "Are you sure you want to delete your account?",
    "deleteaccount_step2_1" : "Please confirm that you want to delete your account and character.",
    "deleteaccount_step2_2" : "Please type \\&quot;Delete\\&quot; to complete the deletion.",
    "deleteaccount_step3" : "Your account will be deleted in 14 days.",
    "accountrecovery_note" : "Note:",
    "accountrecovery_tips" : "You may only revoke account deletion during the 14-day frozen period.",
    "accountrecovery_Submitted2" : "Revocation submitted. Your account will be restored later.",
    "accountrecovery_Failed" : "Failed",
    "accountrecovery_Failed_1" : "Account status is normal. You may log in.",
    "accountrecovery_Failed_2" : "Character information not found.",
    "accountrecovery_success" : "Account restored",
    "account_normal" : "Account status is normal. No need to restore.",
    "account_unablerestore" : "Account has been deleted. Unable to restore.",
    "accountrecovery_roleHolder" : "Enter  your character name",
    "accountrecovery_headerTitle" : "Revoke Account Deletion",
    "guideTitle" : "Your purchase is not successful. Please contact our customer service.",
    "accountFix" : "Account Recovery",
    "inputAccount" : "Please enter the account name that you wish to recover",
    "applyForAccountFix" : "Account Recovery",
    "nonEnterItem" : "Information to add: Registration Date; Model Number; Device Name; Passport or ID Number, Contact E-mail; Please fill in the blanks",
    "resetOT" : "Time out, please submit the Review again",
    "addOT" : "Time out, please submit the Additional Information again",
    "errorPwd" : "Password has to be 6-20 characters, including letters, numbers, \".\", \"_\", \"@\"",
    "verifyAccount" : "Account info is missing, please check again.",
    "selectRegisterTime" : "Please choose your registration time.",
    "enterBindEmail" : "Please insert your verified email.",
    "enterUsedPhoneType" : "Please insert the model of your mobile phone.",
    "enterIdfaGpid" : "Please insert the UDID of your device.",
    "enterContactEmail" : "Incorrect format of Contact E-mail Address; Please re-enter",
    "confirmTermsPrivacy" : "Please read and agree to the service terms and privacy policy.",
    "enterRechargeRemark" : "Please insert your recharge record.",
    "uploadImg" : "Please upload an Image Scan of your ID, maximum size is 20MB",
    "selectIDType" : "Please select the type of your identification document.",
    "enterIDNum" : "Please insert your passport number or ID number.",
    "enterIP" : "Please insert the IP address you used for registration.",
    "enterQueryNum" : "Please enter Review ID",
    "enterQueryPwd" : "Please enter Review Password",
    "errorQueryItem" : "Incorrect Review ID or Password, please try again",
    "enterPassword" : "Please insert a new password.",
    "enterPasswordAgain" : "Please confirm your new password.",
    "enterPasswordNonSame" : "Inconsistent Password",
    "enterEmail" : "Please enter e-mail address",
    "sendSuccess" : "E-mail has been sent",
    "enterCode" : "Please enter the Verification Code",
    "errorCode" : "Incorrect verification code",
    "selectQuest" : "Please select a Security Question",
    "enterAnswer" : "Please enter the answer",
    "selectDifferQuest" : "Please select 3 Security Questions and answers",
    "addSuccess" : "Your information has been submitted.",
    "picFormt" : "Picture format must be jpg, png or gif",
    "countdownBefore" : "Reset Countdown",
    "countdownAfter" : "(The link will expire at 00:00:00, please submit your application again )",
    "uploadDone" : "Upload done",
    "uploadFail" : "Upload failed",
    "applySuccess" : "Application Approved",
    "applyFailed" : "Application Denied",
    "resetQuestAlterFailed" : "Failed to change security question.",
    "resetQuestError" : "Data input error.",
    "resetQuestNone" : "Inquiry order not found.",
    "resetQuestAltered" : "Security questions have been changed.",
    "illegalOperation" : "Illegal Operation",
    "queryNotExist" : "Inquiry number does not exist.",
    "queryPasswordError" : "Find Password Error",
    "auditing" : "Pending approval",
    "notPass" : "Denied",
    "suppleInformation" : "Submit supplementary information",
    "suppleInformationUnHandle" : "Supplementary information submitted, pending process.",
    "suppleInformationTimeout" : "Submit supplementary information timeout.",
    "repairedAccountSuccess" : "Account repair has been completed.",
    "repairedAccountLost" : "Account repair operation has failed.",
    "loginStateNone" : "Not logged in or session has expired.",
    "repairedAccountTimeout" : "Account repair duration has expired.",
    "changePasswordSucc" : "Password changed.",
    "emailSendFailed" : "Failed to send mail.",
    "emailSendLimit" : "The mailbox may not receive any more verification codes today.",
    "repairedAccountTimeout2" : "Illegal operation account repair duration has expired.",
    "emailCodeSended" : "E-mail verification code has been sent.",
    "alterSuccess" : "Change saved",
    "questionAlterSuccess" : "Security question has been changed.",
    "username" : "Account name",
    "code" : "Please enter the verification code here",
    "selectServiceType" : "Please select Service Type",
    "submitForm" : "Submit the Form",
    "apply" : "Apply",
    "reviewApplicationStatus" : "Review Application Status",
    "instantReviewOfTheStatus" : "Instant Review of the Status",
    "reviewStatus" : "Review Status",
    "backToLogin" : "Back to login",
    "previous" : "Previous",
    "applyDesc" : "Please enter the information so that we can help. You must fill in the blanks with a * . If such information was missing in your account, please enter \"None\".",
    "additionalServices" : "Additional Services",
    "resetSecurityEmail" : "Reset Security E-mail",
    "resetSecurityQuest" : "Reset Security Questions",
    "registrationDate" : "Registration Date",
    "month" : "Month",
    "year" : "Year",
    "emailBound" : "E-mail Bound",
    "modelNumber" : "Mobile model type;",
    "deviceName" : "Device Name",
    "provideRecharge" : "Please provide a detailed and complete Recharge Record, including Time, Method, Amount, Order Number, and Transaction ID for us to confirm.",
    "selectCountry" : "Region",
    "passportID" : "Passport/ ID",
    "upload" : "Upload",
    "del" : "delete",
    "pleaseUpload" : "Please upload an Image Scan of your ID, with maximum size of 20MB",
    "uploadAgain" : "Upload again",
    "enterDesc" : "Please enter any information that proves the ownership of the account",
    "contactEmail" : "Contact E-mail",
    "applyNoteAttr" : "Note",
    "applyNoteDate" : "please provide your e-mail address so that you can receive the results of your application",
    "agree" : "I have agreed to",
    "UJOYTerms" : "Terms of Use",
    "privacy" : "Privacy Policy",
    "reviewStatusOfAccountFix" : "Review Status of Account Fix",
    "enterReviewID" : "Please enter Review ID",
    "enterReviewPwd" : "Please enter Review Password",
    "review" : "Review",
    "reviewNoteAttr" : "Note",
    "reviewNoteData" : "Check your Contact E-mail in case you forgot the Review ID and Review Password",
    "haveResetInfo" : "You\'ve reset your info",
    "resetProfile" : "Reset your Profile",
    "desc" : "Congrats! Application approved! Please reset your profile.",
    "changePwd" : "Change Password",
    "resetPwd" : "Reset Password",
    "reset" : "Reset",
    "enterNewPwd" : "Please enter new password",
    "confirmNewPwd" : "Please confirm new password",
    "successResetPwd" : "Successfully Reset password",
    "bindSecurityEmail" : "Bind Security E-mail",
    "resetPwdDesc" : "Reset password when you forgot password or account was stolen",
    "bindCommon" : "Bind",
    "sendCommon" : "Send",
    "enterVcode" : "Please enter the Verification Code",
    "successResetEmail" : "Successfully Reset Security E-mail",
    "resetQuest" : "Reset Security Questions",
    "resetQuestDesc" : "Reset password when you forget your password or you believe your account info was stolen",
    "successResetQuest" : "Successfully Reset Security Questions",
    "hide" : "Hide",
    "addRegisterTime" : "Registration time;",
    "modelNum" : "Model Number: IDFA/GPID",
    "registrationIP" : "Registration IP;",
    "addRechargeRecord" : "Recharge record;",
    "serviceReply" : "Reply from Customer Service:",
    "addDataLimitTime" : "Date for Adding Addititional Information:",
    "addMoreInfo" : "Add More Information",
    "applicationSubmit" : "Application submitted",
    "underReviewStatus" : "Your profile is under review, you will get reply in the next working day. Review status:",
    "reviewID" : "Review ID",
    "reviePwd" : "Review Password",
    "enterReviewIDNPwd" : "Enter Review ID and Review Password to check status",
    "homepage" : "Homepage",
    "checkEmailAttr" : "Note",
    "checkEmailData" : "Check your Contact E-mail in case you forgot your Review ID and Review Password",
    "underReview" : "Under Review",
    "underReviewReply" : "Your profile is under review.We will reply as soon as possible. Thank you for your patience!",
    "failed" : "Application Failed",
    "reason" : "Reason: ### Therefore, application failed, please provide correct information, our staff will help. Thank you for your cooperation!",
    "underReviewAdd" : "Your profile is under review. Part of the information is missing or inconsistent, please add more information for us to confirm!",
    "addInfoRequired" : "Additional Information Required",
    "dateForAddInfo" : "Date for Adding Addititional Information:",
    "addInfo" : "Additional Information",
    "addInfoSubmit" : "Additional Information has been submitted! Thank you for your patience!",
    "hasBeenRepaired" : "Account has been repaired",
    "opExpired" : "Account repair operation expired",
    "approved" : "Approved",
    "haveSubmitted" : "You\'ve submitted",
    "sessionExpired" : "You\'ve not yet logged in or session value has expired",
    "submitted" : "Submitted",
    "addItemRegisterDate" : "E-mail;",
    "addItemDeviceNumber" : "UDID;",
    "reasonItemPwd" : "Inconsistent ID Number;",
    "addItemIDPhoto" : "ID Photo;",
    "idfaTitle" : "How to find your device IDFA or GPID?",
    "idfaSubTitle1" : "For ios user—finding your IDFA",
    "idfaSubTitle1Desc1" : "1.Download the app 【<em>MyIDFA</em>】from App Store",
    "idfaSubTitle1Desc2" : "2.Open this <em>app</em> and you will find your device <em>IDFA</em>.",
    "idfaSubTitle2" : "For Android user—finding your GPID",
    "idfaSubTitle2Desc1" : "1.tab the <em>“settings”</em> button",
    "idfaSubTitle2Desc2" : "2.tab the <em>“Google”</em> icon below the <em>ACCOUNTS</em> page",
    "idfaSubTitle2Desc3" : "3.then tab the <em>“Ads”</em> icon, and you will find your <em>GPID</em>",
    "uploadIDCard" : "Please upload an Image Scan of your ID, with maximum size of 20MB",
    "uploadTipsBefore" : "File size must not be greater than",
    "uploadTipsAfter" : "M",
    "submitError" : "Error caused by missing ID number or wrong account info.",
    "applyLimitError" : "Daily application limit exceeded. (3 times each day)",
    "applyDisabled" : "You may only submit once every 10 minutes.",
    "inputDataError" : "Data is not completed.",
    "dataException" : "Data exception",
    "picSizeLimit" : "Picture file size must not exceed 5MB",
    "picTypeLimit" : "Upload JPG, PNG, GIF files only",
    "picNull" : "Picture is empty",
    "alteredPassword" : "Password has been changed.",
    "inputError" : "Input error.",
    "pwdChangefailed" : "Failed to change password.",
    "sendEmailCodeDisabled" : "Verification code can only be sent again after a period of time.",
    "alteredEmail" : "E-mail has been changed.",
    "inputEmailError" : "E-mail input error",
    "operationFailed" : "Operation failed",
    "codeNull" : "You have not entered a verification code yet.",
    "findPwd" : "Forgot password",
    "findAccountAndPwd" : "Forgot account/password",
    "usualDeviceNum" : "Model Number: IDFA/GPID",
    "usualPhoneNum" : "Device Name",
    "registerTimeError" : "Inconsistent Registration Date;",
    "bindEMailError" : "Inconsistent Bound E-mail;",
    "rechargeRecordError" : "Inconsistent Recharge Record;",
    "registerIPError" : "Inconsistent Registration IP address;",
    "deviceNumError" : "Inconsistent IDFA/GPID;",
    "deviceModelError" : "Inconsistent Device Model;",
    "confirmTerms" : "Please agree to terms of service",
    "applyFixAccount" : "If the above approaches do not work, you may apply for <span>account recovery</span>.",
    "findPwdByFixAccount" : "You are advised to set a security e-mail for account recovery.",
    "connectFail" : "Disconnected from Google Services, please try again",
    "h5_favour_has_gift" : "Bookmark to browser! (This account has claimed the reward already)",
    "h5_favour_get_gift" : "Congrats! You obtained the reward. Please check in-game.",
    "h5_get_gift_fault" : "Unable to claim. Please try again later, and contact our CS if the problem remains.",
    "h5_favour_please_select" : "Please choose server/character",
    "h5_favour_login_get" : "Log in and bookmark to the browser to claim a reward!",
    "h5_favour_tip" : "Bookmark to the browser to claim a reward!",
    "h5_favour_select_serve" : "Please choose server",
    "h5_favour_select_role" : "Please choose character",
    "store_product_paytype_error" : "You may not purchase the selected item through this payment method.",
    "SwitchWithThirdWay" : "Switch to \${type}",
    "moreGame" : "more games",
    "serviceTitle" : "Service",
    "h5_download_login" : "Please log in first.",
    "h5_download_tips" : "Please start the game from the client.",
    "h5_download_repeat_get" : "You have claimed this giftpack.",
    "h5_download_succ" : "Please download the client first.",
    "h5_download_repeat_role" : "Character is bound",
    "currentLoginAccount" : "Current account:",
    "fb_canvas_fullscreen" : "Expand",
    "fb_canvas_website" : "Homepage",
    "fb_canvas_like_share" : "Share",
    "fb_canvas_service" : "Support",
    "fb_canvas_login_fail" : "Login failed",
    "fb_canvas_pay_return" : "You have cancelled the transaction",
    "fb_canvas_root_tip" : "Please log in Facebook to authorize first",
    "h5_popup_title" : "Payment way",
    "h5_popup_submit" : "Pay",
    "h5_popup_last_used" : "Last used",
    "h5_popup_quit_tips" : "Are you sure to cancel payment",
    "h5_popup_quit_check" : "YES",
    "h5_popup_quit_cancel" : "NO",
    "h5_popup_currency_sign" : "\$",
    "h5_popup_product_empty" : "Product information has not been obtained yet. Please refresh page",
    "h5_popup_server_empty" : "There is no server list yet. Please refresh page",
    "aboutRelevanceAccount" : "Already have an account?",
    "selectLoginType" : "Select a login method",
    "touristDescription" : "If you already have an account, you can log in as a guest and then use the OTP (One-Time Password) feature in the user center to switch accounts. This feature requires the OTP functionality to be set up on your mobile device in the user center.",
    "touristSuggest" : "If you already have an account, you can log in as a guest and then tap the \"Switch Account\" option in the user center. From there, you can log in using a previously bound social media account.",
    "h5_tourist_remenber" : "Remember me for 14 days",
    "account_czsm1" : "1、全てのゲームデータが新しい端末に引き継がれます。OSの異なる端末で引き継ぐことも可能です；",
    "account_czsm2" : "2、引き継ぐ時のパスワードを登録してください。",
    "account_czsm3" : "3、セキュリティ保護のため、",
    "account_wzfdmm" : "大文字と小文字を区別して、6-16文字のパスワードをご入力",
    "account_qzcsrmm" : "再度パスワードをご入力",
    "account_fxyjm" : "引き継ぎコード発行",
    "account_yjmsm1" : "1、タイトル画面にある「ユーザーセンター」をタップ、「切り替え」のページで引き継ぎを行ってください。",
    "account_yjmsm2" : "2、引き継ぎナンバーに使用期限はございません。",
    "account_yjmsm3" : "3、引き継ぎコードは一度しか使えません。再度引き継ぐことができます。",
    "account_yjmsm4" : "4、アカウントを保護するため、引き継ぎコードを他人に教えないようにしてください。",
    "account_fz" : "コピー",
    "account_cxfx" : "新規で発行する",
    "account_czsm4" : "アカウントを連携",
    "account_czsm5" : "してください。",
    "account_yjm" : "引き継ぎコード",
    "account_16wzzj" : "パスワードの長さは6～16文字にする",
    "account_qsrzqdyjmhmm" : "正しい引き継ぎコードとパスワードを入力してください。",
    "account_yj" : "引き継ぎ",
    "accoun_lcsrdmmbyz" : "パスワードの両回の入力は一致しない",
    "deleteaccount_step3_1" : "within the 14 days. Revoke now?",
    "account_syyjm" : "1. 引き継ぎコードを使ってゲームデータがこの端末に引き継がれます。",
    "account_yjmznsyyc" : "2. 引き継ぎコードは一度しか使えず、再発行することができます。",
    "account_sryjm" : "引き継ぎコードを入力",
    "account_srmm" : "パスワードを入力",
    "h5_header_gift" : "",
    "h5_award_popup_type" : "",
    "h5_award_popup_content" : "",
    "h5_award_popup_code" : "",
    "h5_favour_gift_name" : "",
    "h5_download_gift_name" : "",
    "h5_award_popup_exchange_way" : "",
    "h5_succ_get_gift" : "",
    "h5_exchange_info_title" : "",
    "h5_exchange_info_1" : "",
    "h5_exchange_info_2" : "",
    "h5_check_gift" : "",
    "account_delete_scdqzh" : "Are you sure you want to delete the account along with its data?",
    "account_delete_fwq" : "Server",
    "account_delete_zhm" : "Character",
    "account_delete_jshflj" : "Character retrieval link",
    "account_delete_qzyzmdxx" : "(Case sensitive)",
    "account_delete_jtbcysxx" : "You are advised to take a screenshot of the above information for account retrieval.",
    "deleteaccount_step3_2" : "After 14 days, your account will be deleted. You will not be able to restore your account. You will lose all your account information.\\n\\nYou may revoke the account deletion through",
    "h5_guest_login" : "Guest",
    "h5_click_copy" : "",
    "questionnaire_btn" : "questionnaire investigation",
    "h5_header_store_text" : "Recharge",
    "h5_header_home_text" : "Homepage",
    "h5_check_gift_list_text" : "Reward Info",
    "yourServer" : "Your Server",
    "allServer" : "All Servers",
    "h5_header_screen" : "Full Screen",
    "h5_verticalTip" : "Landscape mode is advised.",
    "h5_third_party_login_tips" : "If you want to log in using a social media account (such as Facebook, Google, Twitter, etc.), you can first log in as a guest and then bind your social media account in the user center.",
    "webStoreUidTitle" : "",
    "webStoreUidTips" : "",
    "webStoreUidGuide" : "",
    "webStoreUidInputt" : "",
    "feedbackTips" : "",
    "recentPlay" : "Recent",
    "moreGames" : "More",
    "previousSelect" : "Previous",
    "payAgainBtn" : "Top-up again",
    "packageTypeName" : "Pack",
    "coinTypeName" : "Top-up",
    "cardTypeName" : "Monthly Card",
    "orderNormal" : "default",
    "orderPriceUp" : "Price↑",
    "orderPriceDown" : "Price↓",
    "returnSelectRole" : "Return",
    "jiamaInfo" : "Payment Method Bonus\nBonus currency = Amount paid*currency rate * bonus rate x Payment Method Bonus\nBonus currency = Amount paid*currency rate * bonus rate\n*Note: bonus currency will not be counted by top-up events or VIP EXP.*For games that are launched globally,the payment amount is calculated in us dollars.Please contact customer service if you have any questions.",
    "lastSelectTag" : "Used previously",
    "onestore_subscribe_manage" : "Manage",
    "onestore_subscribe_entrance" : "OneStore Subscription",
    "onestore_subscribe_has_expire" : "Expired",
    "onestore_subscribe_expire_time" : "Expire on \${month}/\${day}/\${year}",
    "onestore_subscribe_privacy" : "About Subscription and Privacy",
    "onestore_subscribe_cancel_subscribe" : "Cancel Subscription",
    "onestore_subscribe_info_title" : "Subscription Info",
    "onestore_subscribe_option_title" : "Options",
    "onestore_subscribe_do_not_subscribe" : "No subscribed items.",
    "onestore_subscribe_get_role_fail" : "Failed to subscribe. Please open this page again in the game.",
    "onestore_subscribe_later" : "Later",
    "onestore_subscribe_confirm" : "Confirm",
    "onestore_subscribe_confirm_cancel" : "Confirm Cancellation",
    "onestore_subscribe_popup_tip" : "If you cancel now, you can still access your subscription until \${month}/\${day}/\${year}.",
    "onestore_subscribe_detail_tip" : "Subscribed item will be renewed on \${month}/\${day}/\${year} (Price: \${prices}/month). Subscription can be canceled 1 day before it expires.",
    "onestore_subscribe_expired_tip" : "Please subscribe the expired item from the in-game Mall/Shop",
    "onestore_subscribe_goon_sub" : "Renew on \${month}/\${day}/\${year}",
    "onestore_subscribe_has_cancel_tip1" : "Subscription canceled. You can still access your subscription until \${month}/\${day}/\${year}.",
    "onestore_subscribe_has_cancel_tip2" : "If you wish to subscribe again. Please do so in the in-game Mall/Shop.",
    "onestore_subscribe_cancel_fail" : "Failed to cancel subscription. Please try again later.",
    "onestore_subscribe_cancel_fail_title" : "Cancel Subscription",
    "apple_deleteaccount" : "Delete Account",
    "apple_deleteaccount_title" : "Request account deletion",
    "apple_deleteaccount_step1_1" : "Please read the following terms and conditions carefully:",
    "apple_deleteaccount_step1_2" : "Your account will be frozen for 14 days since the account deletion.",
    "apple_deleteaccount_step1_3" : "Your account will be <span class=\"highlight\">permanently deleted</span> if you do not revoke the deletion process in 14 days. Upon deletion of your account, you will not be able to use it to log into the game. All information on your account will be deleted.",
    "apple_deleteaccount_step1_4" : "If you wish to unlink social media account from the account, please contact the customer service team for unlinking operation before deleting your account. Otherwise, upon successful deletion of your account, you will not be able to use your linked social media account to log into the game.",
    "apple_deleteaccount_step1_5" : "Please make sure you have properly disposed your virtual assets in the game before applying for the deletion of your account.<span class=\"highlight\">If you wish to apply for refund, please also do it before deleting your account</span>.",
    "apple_deleteaccount_step1_6" : "You may revoke the deletion within the 14 days through the link below, please save the link in advance:",
    "apple_deleteaccount_step2_1" : "Have you properly disposed your virtual assets in the game? If you haven\'t, please contact the customer service team for the matter before submitting an account deletion request.",
    "apple_deleteaccount_step2_2" : "Please save your server and character information which will be required for restoring your account.",
    "apple_deleteaccount_step2_3" : "Please type \"Delete\" to complete the deletion",
    "apple_deleteaccount_step3_1" : "Your account deletion request has been submitted. The following account is now frozen:",
    "apple_deleteaccount_step3_2" : "We will permanently delete your account after 14 days if there is no further request for revoking the deletion from you.",
    "apple_deleteaccount_step3_3" : "You can visit the following link to revoke the deletion within the 14 days period",
    "apple_deleteaccount_step4_1" : "You have deleted your old account. Please log in with a new account next time.",
    "apple_deleteaccount_agree" : "I have read and agree to the terms and conditions above",
    "apple_deleteaccount_server" : "Server",
    "apple_deleteaccount_roleName" : "Character",
    "copyLink" : "Copy Link",
    "copyTextAndImg" : "please copy and save the link or take a screenshot",
    "copyLinkAndRoleInfo" : "Copy Link & Character",
    "hasCopy" : "Copied to clipboard",
    "quickcard_tips" : "The information of your credit card has been encrypted and secured by Worldpay. The displayed information is only to provide a better experience.",
    "quickcard_use_new_card" : "New credit card",
    "edit" : "Edit",
    "save" : "Save",
    "quickcard_confirm_delete" : "Delete?",
    "quickcard_popup_tip" : "If you want to use this card again after deleting it, please choose the \"New credit card\" option.",
    "quickcard_result_tip_one" : "lf you chose to save your card number on the previous page, we would collect the data of your card (**** **** **** 1234) in encrypted version.",
    "quickcard_result_tip_two" : "We store encrypted details only for your convenience, and you do not have to input card numbers at your next purchase.",
    "quickcard_learn_more" : "Learn more 》",
    "quickcard_info_title" : "Stored Credentials Statements",
    "quickcard_info_tip_one" : "To better protect customer data security.,Visa and Mastercard are introducing new definitions for these \'stored credentials\', and new rules for stored credential and merchant initiated transactions.",
    "quickcard_info_tip_two" : "When you make a purchase on our website, we collect the data of your card (1234 **** **** 1234） in encrypted version. We will hold the encrypted details for 4 years and will update the agreement, privacy policy on our website in case there is any changes.We store encrypted details only for your convenience, and you do not have to input card numbers at your next purchase.",
    "search_product" : "find item",
    "search_price" : "find price",
    "price" : "price",
    "product_no_found" : "No items are found",
    "price_no_found" : "No price are found",
    "search_no_found" : "No items/price are found",
    "product" : "item",
    "store_tag_hot" : "HOT",
    "store_tag_discount" : "Discount",
    "store_tag_double" : "Double",
    "store_tag_treble" : "Treble",
    "store_tag_sale" : "SALE",
    "store_tag_top_seller" : "TOP SELLER",
    "store_tag_off_10" : "10%OFF",
    "store_tag_off_20" : "20%OFF",
    "store_tag_off_30" : "30%OFF",
    "store_tag_off_40" : "40%OFF",
    "store_tag_off_50" : "50%OFF",
    "store_tag_off_60" : "60%OFF",
    "store_tag_off_70" : "70%OFF",
    "store_tag_off_80" : "80%OFF",
    "store_tag_off_90" : "90%OFF",
    "store_tag_event" : "Event",
    "store_tag_daily" : "Daily",
    "store_tag_weekly" : "Weekly",
    "store_tag_monthly" : "Monthly",
    "subscriptionTypeName" : "subscription",
    "useDoubleSend" : "Use Box Multiplier?",
    "doubleSendInfo" : "Since you used a Box Multiplier, some of the items you purchased were doubled (as shown at the bottom)!",
    "storeRoleTitle" : "Please Choose Character",
    "storeSocialLogin" : "Log in with SNS accounts",
    "storeAccountIdLogin" : "Log in with account ID",
    "storeInputId" : "Enter account ID",
    "storeSearch" : "Search",
    "storeSelectProductTitle" : "Choose Items",
    "storeInputNameSearch" : "Enter item name and search",
    "storeInputPriceSearch" : "Enter item price and search",
    "storeNoFindProduct" : "Item not found. Please try again.",
    "storePriceUp" : "Price↑",
    "storePriceDown" : "Price↓",
    "storeLookDetail" : "Details",
    "storeChangeProduct" : "Change Item",
    "storeWelcome" : "Welcome",
    "storeLookMore" : "More",
    "storeHasSelect" : "Item Selected",
    "storeTotal" : "Total",
    "storeExtra" : "Bonus",
    "storeProductDetail" : "Details",
    "storeUidGuideStep1" : "Tap Settings > More > Account",
    "storeUidGuideStep2" : "Enter the account ID when topping up",
    "storeSelectAndLook" : "Please select your character first",
    "storeSwitchWay" : "Switch Login Method",
    "type1" : "Daily Sale",
    "type2" : "Hero",
    "type3" : "Battle Gear",
    "type4" : "",
    "type5" : "Chip",
    "type6" : "Nova",
    "type7" : "Resource",
    "type8" : "Build Speedup",
    "type9" : "Rare Items",
    "type10" : "Alliance",
    "type11" : "Diamond",
    "type12" : "Module",
    "type13" : "Cube",
    "type14" : "",
    "type15" : "Nanoweapon",
    "type16" : "Grand Prize",
    "type17" : "",
    "type9999" : "Limited Offer",
    "type10000" : "Gift Center",
    "type10001" : "Holiday Events",
    "typeother" : "Other items",
    "switchChar" : "Switch Character",
    "howToFindUid" : "How to find my account ID?",
    "choosePayWay" : "Choose a Payment Method",
    "new_apple_deleteaccount_stepsub_title" : "Cancel Auto-Renewal",
    "new_apple_deleteaccount_stepsub_1" : "An auto-renewal subscription is found under your account. You are advised to cancel the auto-renewal before deleting your account to avoid any unintentional purchases.",
    "new_apple_deleteaccount_stepsub_2" : "Cancel Auto-Renewal",
    "new_apple_deleteaccount_stepsub_later" : "Later",
    "new_apple_deleteaccount_stepsub_now" : "Now",
    "new_apple_deleteaccount_title" : "Request account deletion",
    "new_apple_deleteaccount_step1_1" : "Please read the following terms and conditions carefully:",
    "new_apple_deleteaccount_step1_2" : "Your account will be <span class=\"highlight\">permanently deleted</span> upon deletion. You will NOT be able to use it to log into the game. <span class=\"highlight\">Player data</span> (including but not limited to in-game currency, items, etc.) linked to this account will also be permanently removed (unless the law in your country/region states otherwise).",
    "new_apple_deleteaccount_step1_3" : "If you wish to unlink social media account from the account, please contact the customer service team for unlinking operation before deleting your account. Otherwise, upon successful deletion of your account, you will not be able to use your linked social media account to log into the game.Please make sure you have properly disposed your virtual assets in the game before applying for the deletion of your account.",
    "new_apple_deleteaccount_step1_4" : "<span class=\"highlight\">If you wish to apply for refund, please also do it before deleting your account. </span>Please make sure you have properly disposed of your virtual assets before deleting your account.",
    "new_apple_deleteaccount_step2_1" : "Have you properly disposed your virtual assets in the game? If you haven\'t, please contact the customer service team for the matter before submitting an account deletion request.",
    "new_apple_deleteaccount_step2_2" : "Please key in \"Delete\" to complete the deletion. Account deletion cannot be revoked once executed.",
    "new_apple_deleteaccount_step2_3" : "Please key in \"Delete\" to complete the deletion",
    "new_apple_deleteaccount_step3_1" : "Your account deletion request has been submitted. The following account has since been deleted:",
    "new_apple_deleteaccount_step3_2" : "Please create a new account if you wish to log in to the game again.",
    "new_apple_deleteaccount_step4_1" : "You have deleted your old account. Please log in with a new account next time.",
    "currencyTypeName" : "Currency",
    "has_select_product" : "Your Items:",
    "n_product" : "\${n}",
    "look_detail_product" : "View All",
    "limit_buy_product" : "Purchase limit for this item: \${n}",
    "limit_order" : "You can only buy a maximum of \${n} items each time.",
    "limit_order_remove_tip" : "You have reached the purchase limit for some items in this cart. Do you want to remove them?",
    "paytype_limit" : "This payment method cannot be used to buy some of your items. Please choose a different payment method or try buying them separately.",
    "check_remove_cart" : "Remove from cart?",
    "remove_cart" : "Remove",
    "confirm_product" : "Confirm",
    "select_paytype" : "Select Payment Method",
    "cart_is_empty_tip" : "No items found. Please select an item first.",
    "thirty_tip" : "If the items you have purchased fail to arrive within 30 minutes, please contact our customer support.",
    "total_n_product" : "Item x\${n}",
    "look_detail_of_cart" : "View All",
    "order_detail" : "Item List",
    "total_detail" : "Quantity:",
    "add_to_cart" : "Add to Cart",
    "back_to_select" : "Back",
    "fail_and_later" : "Item info error. Please try again later.",
    "nextStep" : "NEXT",
    "pnsGameName" : "Puzzles & Survival",
    "enterOfficial" : "Visit \nWebsite",
    "visitorLogin" : "Guest",
    "tokenLogin" : "OTP",
    "fbLogin" : "log in with Facebook",
    "googleLogin" : "Log in with Google",
    "twitterLogin" : "Log in with Twitter",
    "vkLogin" : "Log in with VK",
    "agreementTextStart" : "By logging into the game, you confirm that you have read and agree to the Terms of Service and Privacy Policy.",
    "userCenter" : "User Center",
    "welcomeBack" : "Welcome Back",
    "continueGame" : "START",
    "officialPay" : "Top-Up Center",
    "changeAccount" : "Switch Account",
    "back" : "Back",
    "tokenKey" : "OTP",
    "inputUid" : "Enter your UID",
    "inputToken" : "Enter your OTP",
    "inputCkCode" : "Type the text",
    "enterGame" : "START",
    "tokenTip" : "Protect Your Account With OTP Verification",
    "howToGetToken" : "How to get my one-time password?",
    "getStep1" : "Step 1: Go to Settings > Account > User Center",
    "getStep2" : "Step 2: Tap OTP",
    "getStep3" : "Step 3: Copy and enter your UID and one-time password",
    "copy" : "Copy",
    "lastRefresh" : "Refreshes in:",
    "second" : "s",
    "immediatelyRefresh" : "Refresh Now",
    "frequently" : "Operation too frequent. Please try again later.",
    "loginFail" : "Login failed. Incorrect password.",
    "tokenIntro" : "About One-Time Password (OTP)",
    "tokenIntro1" : "1. One-time passwords expire in 120 seconds. Use them wisely to keep your account safe and secure.",
    "tokenIntro2" : "2. Staff won\'t ask for your one-time password. Please never share or give out your password.",
    "nextStep1" : "NEXT",
    "couponCanUse" : "Usable",
    "couponCanNotUse" : "Unusable",
    "couponHasNoCoupon" : "No coupons",
    "couponUseTip" : "Use 1 coupon for each order",
    "couponValidTime" : "Validity",
    "couponFuilCanUse" : "Usable for orders over  \${price} \${currency}",
    "couponNoLimit" : "No limitations",
    "couponAllProductCanUse" : "All items",
    "couponPartProductCanUse" : "Specific items",
    "couponPartPaytypeCanUse" : "Specific payment channels",
    "couponOnlyCoinCanUse" : "For in-game currency only",
    "couponOnlyDiamondCanUse" : "For diamonds only",
    "couponOnlyPackageCanUse" : "For packs only",
    "couponOnlySubCanUse" : "For subscriptions only",
    "couponOnlyDaibiCanUse" : "For tokens only",
    "couponMaxDiscount" : "Discount up to \${price} \${currency}",
    "couponHasUsed" : "Used",
    "couponReductionType" : "Deduction",
    "couponDiscountType" : "Discount",
    "couponUseNow" : "Use",
    "couponHasNoSelect" : "Not using coupon",
    "couponHasSelectQuan" : "Discounted",
    "couponSubmitTip" : "Coupons will be used",
    "couponCanUseQuan" : "Coupons",
    "couponOrderTotal" : "Total",
    "couponHasDiscount" : "Discount",
    "couponPayTotal" : "Payment",
    "couponCancel" : "Cancel",
    "couponConfirm" : "Confirm",
    "uidLoginName" : "Log in with OTP",
    "uidToken" : "OTP",
    "uidInputUid" : "Enter your UID",
    "uidInputToken" : "Enter your OTP",
    "uidInputCode" : "Type the text",
    "uidTipTitle" : "Protect Your Account With OTP Verification",
    "uidTipHowToGet" : "How to get my one-time password?",
    "uidTipStep1" : "Step 1: Go to Settings > Account > User Center",
    "uidTipStep2" : "Step 2: Tap OTP",
    "uidTipstep3" : "Step 3: Copy and enter your UID and one-time password",
    "uidTipIntro1" : "1. One-time passwords expire in 60 seconds. Use them wisely to keep your account safe and secure.",
    "uidTipIntro2" : "2. Staff won\'t ask for your one-time password. Please never share or give out your password.",
    "couponMyQuan" : "Coupons",
    "couponSelectPaytypeTip" : "Select payment channel to see discount info",
    "couponSelectCouponTip" : "Select coupons to see discounted price",
    "couponValidQuanTip" : "(Coupon x\${num} usable)",
    "couponLookCart" : "Cart",
    "couponUnfoldCart" : "Hide",
    "couponCoupon" : "Coupon",
    "couponNoUse" : "Not using",
    "couponSelect" : "Select Coupon",
    "couponSureUse" : "Use",
    "couponReturn" : "Back",
    "couponInvalidTime" : "Expires",
    "couponBuyNow" : "Buy Now",
    "couponAllType" : "all",
    "ztmslgType1" : "Daily Sale",
    "ztmslgType2" : "Hero",
    "ztmslgType3" : "Battle Gear",
    "ztmslgType4" : "",
    "ztmslgType5" : "Chip",
    "ztmslgType6" : "Nova",
    "ztmslgType7" : "Resource",
    "ztmslgType8" : "Build Speedup",
    "ztmslgType9" : "Rare Items",
    "ztmslgType10" : "Alliance",
    "ztmslgType11" : "Diamond",
    "ztmslgType12" : "Module",
    "ztmslgType13" : "Cube",
    "ztmslgType14" : "",
    "ztmslgType15" : "Nanoweapon",
    "ztmslgType16" : "Grand Prize",
    "ztmslgType17" : "Core",
    "ztmslgType9999" : "Limited Offer",
    "ztmslgType10000" : "Gift Center",
    "ztmslgType10001" : "Holiday Events",
    "ztmslgTypeother" : "Other",
    "antslgType1" : "Daily Sale",
    "antslgType2" : "Specialized Ant",
    "antslgType3" : "Gear",
    "antslgType5" : "Gene",
    "antslgType6" : "Snail",
    "antslgType7" : "Resources",
    "antslgType8" : "Build & Research",
    "antslgType9" : "Rare Items",
    "antslgType10" : "Alliance",
    "antslgType11" : "Diamond",
    "antslgType12" : "Cell",
    "antslgType13" : "Totem",
    "antslgType9999" : "Limited Offer",
    "antslgTypeother" : "other",
    "typeall" : "All Products",
    "vipHead" : "VIP Points",
    "vipHead213": "Premium Membership",
    "vipTitle" : "VIP Points Event",
    "nowLevel" : "Your level:",
    "myVipScore" : "Your pts:",
    "nextLevelNeed" : "(Earn \${num} more points to get VIP \${level})",
    "ruleTitle" : "Rules:",
    "ztmslgVipRule1" : "1. Event starts at 00:00 (UTC) 2022/09/22",
    "ztmslgVipRule2" : "2. Available games:  Puzzles & Survival",
    "ztmslgVipRule3" : "Each type of event reward can only be claimed once.",
    "ztmslgVipRule4" : "3. Login Coupon event: when logging in to the top-up page for the first time, you will be able to claim a 15%OFF coupon.",
    "ztmslgVipRule5" : "4. VIP Points event: purchase item via our official page to earn points and get level coupons and weekly coupons.",
    "ztmslgVipRule6" : "5. The points you may earn might vary according to the currency you are using. For more details, please check the link at the bottom.",
    "ztmslgVipRule7" : "6. When using coupons, you will earn points based on the amount you\'ve paid after coupons are deducted.",
    "ztmslgVipRule8" : "7. The points you\'ve earned will expire in 365 days. This might affect your VIP level.",
    "ztmslgVipRule9" : "8. You will immediately receive a coupon for reaching a VIP level for the first time. The weekly coupon will be claimable at 00:00 (UTC+0) every Saturday.",
    "ztmslgVipRule10" : "9. You will need to log in to claim the weekly coupon. Don\'t miss out!",
    "ztmslgVipRule11" : "10. The currency of the coupon will be the currency of the last order you have made. Please contact our customer service if you wish to change the currency you are using.",
    "ztmslgVipRule12" : "11. See the table below for more details on the VIP levels and coupons.",
    "ztmslgVipRule13" : "12. In case of any dispute, the support team of Puzzles & Survival has sole and final discretion of interpretation of these Terms and Conditions.",
    "vipLevel" : "VIP Level",
    "vipCondition" : "Required pts",
    "firstSend" : "First time reaching gift",
    "weeklySend" : "Weekly coupon",
    "lastAllCoupon" : "Coupons of previous tier",
    "besides" : "Currency/Points Table:",
    "couponRatio" : "Currency/Points Rate",
    "backToPay" : "BACK",
    "quanGift" : "COUPON",
    "quanGiftTips" : "You have claimable coupon(s)!",
    "antslgVipRule1": "Due to a feature update, the \"VIP Points\" event will soon be discontinued.",
    "antslgVipRule2": "Please make sure to use the coupons obtained from the \"VIP Points\" event before they expire.",
    "antslgVipRule3": "End Time: 2024/09/28 00:00:00 (UTC)",
    "antslgVipRule4": "After the event ends, you can visit the Premium Membership Center to enjoy more benefits:",
    "antslgVipRule5": "Complete quests to earn points, which can be exchanged for coupons, in-game items, and other rewards! Enjoy exclusive member benefits and lucky draws.",
    "antslgVipRule6": "Stay tuned for more rewards and events!",
    "dzgVipRule0" : "1. Event starts at 00:00 (UTC) 2022/09/27",
    "dzgVipRule1" : "1. Available games: \${gameName}",
    "dzgVipRule2" : "Each type of event reward can only be claimed once.",
    "dzgVipRule3" : "2. Login Coupon event: when logging in to the top-up page for the first time, you will be able to claim a 15%OFF coupon.",
    "dzgVipRule4" : "3. VIP Points event: purchase item via our official page to earn points and get level coupons and weekly coupons.",
    "dzgVipRule5" : "4. The points you may earn might vary according to the currency you are using. For more details, please check the link at the bottom.",
    "dzgVipRule6" : "5. When using coupons, you will earn points based on the amount you\'ve paid after coupons are deducted.",
    "dzgVipRule7" : "6. The points you\'ve earned will expire in 365 days. This might affect your VIP level.",
    "dzgVipRule8" : "7. You will immediately receive a coupon for reaching a VIP level for the first time. The weekly coupon will be claimable at 00:00 (UTC+0) every Saturday.",
    "dzgVipRule9" : "8. You will need to log in to claim the weekly coupon. Don\'t miss out!",
    "dzgVipRule10" : "9. The currency of the coupon will be the currency of the last order you have made. Please contact our customer service if you wish to change the currency you are using.",
    "dzgVipRule11" : "10. See the table below for more details on the VIP levels and coupons.",
    "dzgVipRule12" : "11. In case of any dispute, the support team of Ant Legion has sole and final discretion of interpretation of these Terms and Conditions.",
    "213dzgVipRule1" : "Due to a feature update, the \"VIP Points\" event will soon be discontinued.",
    "213dzgVipRule2" : `Please make sure to use the coupons obtained from the "VIP Points" event before they expire.`,
    "213dzgVipRule3" : "End Time: 2024/08/19 08:00:00 (UTC)",
    "213dzgVipRule4" : "After the event ends, you can visit the Premium Membership Center to enjoy more benefits:",
    "213dzgVipRule5" : "Complete quests to earn points, which can be exchanged for coupons, in-game items, and other rewards! Enjoy exclusive member benefits and lucky draws.",
    "213dzgVipRule6" : "Stay tuned for more rewards and events!",
    "getReward" : "Exclusive avatar frames",
    "unbindEntry" : "Link/Unlink Account",
    "unbindApply" : "Unlink",
    "unbindConfirmTitle" : "Are you sure you want to unlink account?",
    "unbindConfirmTip" : "Unlinking account might lead to lost of game save/progress.",
    "unbindConfirm" : "Still unlink",
    "unbindExit" : "Exit",
    "unbindSucc" : "Account unlinked",
    "unbindFail" : "Failed to unlink your account. Please contact our customer service.",
    "unbindServiceTitle" : "Please file for a manual unlink operation.",
    "unbindContact" : "Customer Service",
    "unbindServiceTip" : "You may not unlink your account. Please contact our customer service.",
    "antslgType15" : "Legacy",
    "shareEventTitle" : "Invite Friends</br>Earn Rewards",
    "shareRule" : "Rules",
    "awardBag" : "My Reward",
    "initiatorText" : "I\'m an Inviter",
    "inviteeText" : "I\'m an Invitee",
    "createCode" : "Create Invite Code",
    "createCodeTip" : "Tap to create an invite code",
    "createLinkTip" : "Tap to create an invite link",
    "copyText" : "Copy",
    "shareCode" : "Share Invite Code",
    "twShare" : "",
    "fbShare" : "",
    "dcShare" : "",
    "seeAward" : "View Reward",
    "seeAwardTip" : "Please check your rewards in <span class=\"see-light\">VIP Point</span> > <span class=\"see-light\">My Coupon</span>.",
    "inviteReward" : "Invitation Reward",
    "inviteRewardTip" : "The inviter can only claim these rewards when each invitee achieves these goals for the first time",
    "overweightReward" : "Bonus Reward",
    "resetTip" : "Resets at 00:00 on the last day of each month.（UTC+0）",
    "rewardText1" : "Total Top-up by the Invitee: \$9.99",
    "rewardText2" : "Total Top-up by the Invitee: \$49.99",
    "rewardText3" : "Total Top-up by the Invitee: \$99.99",
    "rewardText4" : "Get 12% OFF Coupon x1 for Every 5 Players Invited",
    "rewardText5" : "Get 15% OFF Coupon x1 After Your Invitees Top Up a Total of \$1,000",
    "invitationList" : "My Invitation",
    "refresh" : "Refresh",
    "invitedTotal" : "Invited: \${total}",
    "storedTotal" : "Total Top-up: \${total} USD",
    "people" : "",
    "invitedPeople" : "Invitee",
    "invitedTime" : "Invited",
    "got" : "Achieved",
    "get" : "Unachieved",
    "overlay" : "Stackable",
    "couponText" : "Coupon",
    "personalReward" : "Top-up Reward",
    "personalRewardText1" : "Total Top-up Reaches \$9.99",
    "personalRewardText2" : "Total Top-up Reaches \$49.99",
    "personalRewardText3" : "Total Top-up Reaches \$99.99",
    "inputCode" : "Enter the invite code",
    "bindCode" : "Confirm",
    "bindSucc" : "Bound",
    "codeTip1" : "Code doesn\'t exist.",
    "codeTip2" : "Invite Code Bound",
    "copySucc" : "Success!",
    "awardName" : "Reward",
    "getTime" : "Obtained",
    "getCondition" : "Requirement",
    "couponText1" : "6% OFF Coupon",
    "couponText2" : "8% OFF Coupon",
    "couponText3" : "10% OFF Coupon",
    "couponText4" : "12% OFF Coupon",
    "couponText5" : "15% OFF Coupon",
    "ruleText1" : "1. Event start time: 2022/11/25, 00:00 UTC",
    "ruleText2" : "2. Event game: Puzzles & Survival",
    "ruleText3" : "3. \"Official Top-up Site Sharing\" event: Share this official top-up site with your friends and invite them to top-up. If they top-up a certain amount through this page, you will be rewarded.",
    "ruleText4" : "4. Monthly Rewards from third party payment: Achieve monthly sharing goals to win rewards.Sharing rewards reset every month.",
    "ruleText5" : "5. Monthly Rewards requires at least one successful top-up payment on the third party site by new players you have invited.",
    "ruleText6" : "6. Monthly Rewards reset on the first day of each month. This also resets any progress from the previous month.",
    "ruleText7" : "7. The rewarded coupon should be claimed by logging in to the third party top-up site. You will not receive another coupon if it has expired.",
    "ruleText8" : "8. The coupon uses the same currency you\'ve used in previous successful top-ups.",
    "ruleText9" : "9. You cannot use another player\'s invite code if they have already used yours.",
    "ruleTableTitle1" : "Rules：",
    "ruleTableTitle2" : "VIP Tiers and Coupons Explained:",
    "ruleTableHead1" : "Top-up Requirement",
    "ruleTableHead2" : "Rewards Requirement",
    "ruleTableHead3" : "Rewards",
    "ruleTableContent1" : "Invite 5 new players",
    "ruleTableContent2" : "Invited players top-up \$1,000 USD",
    "errorTip" : "Operation failed",
    "eventShareText1" : "Puzzles & Survival Limited-Time Offers",
    "eventShareText2" : "Loads of Gifts Await!",
    "cartDoubleTip" : "Box Multipliers are not supported.",
    "codeTip3" : "Not logged in",
    "codeTip4" : "Parameter missing",
    "codeTip5" : "Cannot bind your own invite code",
    "codeTip6" : "Invite code created",
    "payWelfare" : "Top-up Gift",
    "wallet" : "Wallet",
    "myDiscount" : "My Coupon",
    "knowMore" : "More",
    "backPay" : "Back",
    "curBalance" : "Balance",
    "pay" : "Top Up",
    "changeCoin" : "Switch Currency",
    "watchDesc" : "View Details",
    "getMore" : "Get More",
    "getDiscount" : "Claim Your Coupons",
    "notOpenDiscountQuan" : "No events. Please stay tuned!",
    "abountZbit" : "About \${Z-BIT}",
    "remain" : "Left:",
    "payRemain" : "Amount left after purchase:",
    "payRemainExpiry" : "Remaining balance expected after payment: ${money} (Expires on January 1, 2026, please use promptly)",
    "balanceNotEnoughExpiry" : "Insufficient balance (Expires on 01/01/26, recharge not supported)",
    "balanceNotEnoggh" : "Not enough balance. Please top up first.",
    "goToPay" : "Top Up",
    "chooseOtherPay" : "Other Payment Methods",
    "payIntro" : "Top-up Details",
    "logRole" : "Select Character",
    "chooseProduct" : "Select Items",
    "meAgree" : "I have read and agree to the terms.",
    "coinAgreeText" : "",
    "aboutCoin" : "",
    "coinsPayTokenLogin" : "Dynamic verification is required before using \${Z-BIT}",
    "dl3dvnVipRule1" : "1. Available games: \${gameName}",
    "dl3dvnVipRule2" : "Each type of event reward can only be claimed once.",
    "dl3dvnVipRule3" : "2. Login Coupon event: when logging in to the top-up page for the first time, you will be able to claim a 15%OFF coupon.",
    "dl3dvnVipRule4" : "3. VIP Points event: purchase item via our official page to earn points and get level coupons and weekly coupons.",
    "dl3dvnVipRule5" : "4. The points you may earn might vary according to the currency you are using. For more details, please check the link at the bottom.",
    "dl3dvnVipRule6" : "5. When using coupons, you will earn points based on the amount you\'ve paid after coupons are deducted.",
    "dl3dvnVipRule7" : "6. The points you\'ve earned will expire in 365 days. This might affect your VIP level.",
    "dl3dvnVipRule8" : "7. You will immediately receive a coupon for reaching a VIP level for the first time. The weekly coupon will be claimable at 00:00 (UTC+0) every Saturday.",
    "dl3dvnVipRule9" : "8. You will need to log in to claim the weekly coupon. Don\'t miss out!",
    "dl3dvnVipRule10" : "9. The currency of the coupon will be the currency of the last order you have made. Please contact our customer service if you wish to change the currency you are using.",
    "dl3dvnVipRule11" : "10. See the table below for more details on the VIP levels and coupons.",
    "dl3dvnVipRule12" : "",
    "dl3dvnVipRule13" : "12. In case of any dispute, the support team of Ant Legion has sole and final discretion of interpretation of these Terms and Conditions.",
    "codeTip7" : "Cannot use target player\'s code as they already used yours",
    "ruleText10" : "10. Puzzles & Survival official management reserves any rights for final interpretation.",
    "payCoins" : "Top-up VIP Point",
    "shareGift" : "Share for Gifts",
    "attentionCoinUse" : "Note: The balance in each currency is handled separately.",
    "noPayWay" : "There are no payment methods available in the selected region. Please change the region and try again.",
    "dl3dtwVipRule1" : "1. Available games: \${gameName}",
    "dl3dtwVipRule2" : "Each type of event reward can only be claimed once.",
    "dl3dtwVipRule3" : "2. VIP Points event: purchase item via our official page to earn points and get level coupons and weekly coupons.",
    "dl3dtwVipRule4" : "3. The points you may earn might vary according to the currency you are using. For more details, please check the link at the bottom.",
    "dl3dtwVipRule5" : "4. When using coupons, you will earn points based on the amount you\'ve paid after coupons are deducted.",
    "dl3dtwVipRule6" : "5. The points you\'ve earned will expire in 365 days. This might affect your VIP level.",
    "dl3dtwVipRule7" : "6. You will immediately receive a coupon for reaching a VIP level for the first time. The weekly coupon will be claimable at 00:00 (UTC+0) every Saturday.",
    "dl3dtwVipRule8" : "7. You will need to log in to claim the weekly coupon. Don\'t miss out!",
    "dl3dtwVipRule9" : "8. The currency of the coupon will be the currency of the last order you have made. Please contact our customer service if you wish to change the currency you are using.",
    "dl3dtwVipRule10" : "9. See the table below for more details on the VIP levels and coupons.",
    "dl3dtwVipRule11" : "10. In case of any dispute, the support team of Ant Legion has sole and final discretion of interpretation of these Terms and Conditions.",
    "eventInviteSucc" : "Successfully Invite A Friend",
    "eventGainCondition" : "Requirements",
    "eventSuccInvite" : "Successfully invite a friend",
    "eventInviteGainOne" : "Total Top-up by the Invitee: \$49.99",
    "eventInviteGainTwo" : "Total Top-up by the Invitee: \$99.99",
    "eventFriendCode" : "Your Friend\'s Code:",
    "eventCheckBind" : "Bind?",
    "eventConfirm" : "Confirm",
    "eventCancel" : "Cancel",
    "eventBindSucc" : "Successfully bound!",
    "eventGainCoupon" : "You obtained a coupon.",
    "eventLookCoupon" : "View Coupon",
    "eventSuccBind" : "Successfully bound",
    "recaptchaTip" : "Please verify first",
    "inputAccountName" : "Please enter the account you would like to recover",
    "pwaPayTip" : "Quick Access, Better Experience",
    "pwsInstall" : "Add to Home Screen",
    "ztmslgType999" : "Voucher",
    "coinUseTips" : "Upon purchase, Vouchers will be sent to your in-game mailbox. Vouchers can be used to purchase items from the Voucher Mall in-game. Vouchers used to purchase items will count towards your total top-up.",
    "notice" : "Notice",
    "popupConfirm" : "Confirm",
    "hideWithinWeek" : "Don\'t show again for 7 days",
    "ztmslgProductOffTips" : "We have received a lot of feedback regarding the changes to the payment page that were due to be implemented on March 13th. In response to this, we have decided to cancel these changes and will focus on improving your shopping experience. We appreciate your opinions and thank you for your understanding and support. If you have any further questions, please don\'t hesitate to contact our Customer Support team.",
    "couponTopLimit" : "Maximum Deductible Amounts by Currency",
    "swsjpVipRule1" : "1. Event starts at 00:00 (UTC) 2023/03/24",
    "swsjpVipRule2" : "2. Available games: \${gameName}",
    "swsjpVipRule3" : "Each type of event reward can only be claimed once.",
    "swsjpVipRule4" : "3. Login Coupon event: when logging in to the top-up page for the first time, you will be able to claim a 15%OFF coupon.",
    "swsjpVipRule5" : "4. VIP Points event: purchase item via our official page to earn points and get level coupons and weekly coupons.",
    "swsjpVipRule6" : "5. The points you may earn might vary according to the currency you are using. For more details, please check the link at the bottom.",
    "swsjpVipRule7" : "6. When using coupons, you will earn points based on the amount you\'ve paid after coupons are deducted.",
    "swsjpVipRule8" : "7. You are already granted points for purchases you made previously.",
    "swsjpVipRule9" : "8. The points you\'ve earned will expire in 365 days. This might affect your VIP level.",
    "swsjpVipRule10" : "9. You will immediately receive a coupon for reaching a VIP level for the first time. The weekly coupon will be claimable at 00:00 (UTC+0) every Saturday.",
    "swsjpVipRule11" : "10. You will need to log in to claim the weekly coupon. Don\'t miss out!",
    "swsjpVipRule12" : "11. The currency of the coupon will be the currency of the last order you have made. Please contact our customer service if you wish to change the currency you are using.",
    "swsjpVipRule13" : "12. In case of any dispute, the support team of \${gameName} has sole and final discretion of interpretation of these Terms and Conditions.",
    "beautyVipRule1" : "",
    "beautyVipRule2" : "",
    "beautyVipRule3" : "",
    "beautyVipRule4" : "",
    "beautyVipRule5" : "",
    "beautyVipRule6" : "",
    "beautyVipRule7" : "",
    "beautyVipRule8" : "",
    "beautyVipRule9" : "",
    "beautyVipRule10" : "",
    "beautyVipRule11" : "",
    "antslgType999" : "Voucher",
    "passAskMods" : "Ask Mod",
    "passAskModsTip" : "Ask Moderators any questions regarding the game.",
    "passService" : "Customer Query",
    "passServiceTip" : "For any queries regarding account and top-up, please contact our customer service.",
    "passIKonw" : "OK",
    "passGoOn" : "Continue",
    "voucherTitle" : "Official Top-up Center",
    "voucherAddHome" : "Add to Desktop",
    "voucherAddHomeTipOne" : "Faster Payment, Better Experience",
    "voucherAddHomeTipTwo" : "Tap [Share] in the toolbar",
    "voucherAddHomeTipThree" : "Select [Add to Desktop]",
    "voucherLoginLook" : "Log in to view offers",
    "voucherSwitchRole" : "Switch Character",
    "voucherCoupon" : "Coupons",
    "voucherVip" : "VIP Point",
    "voucherMoreCoupon" : "More Offers",
    "voucherAccountId" : "Account ID",
    "voucherOtp" : "OTP",
    "voucherOtherWayPay" : "Choose another way to pay",
    "voucherOtherLoginWay" : "Try another way",
    "voucherCouponActivity" : "Discount Sales",
    "voucherActivityNotBegin" : "Event not started yet.",
    "voucherGoCommunity" : "Learn more about top-up benefits in the community",
    "voucherValidTime" : "Validity",
    "voucherLimitRegion" : "For \${currency} only",
    "voucherLiuyi" : "No available coupons. Please pay attention to future events.",
    "voucherPay" : "Buy Vouchers",
    "voucherAbout" : "About Voucher",
    "voucherChooseWay" : "Select Payment Method",
    "voucherMoreWay" : "More Payment Methods",
    "voucherChooseCoupon" : "Select Coupon",
    "voucherHasChoose" : "Selected",
    "voucherMoneyInsufficient" : "Insufficient balance",
    "voucherContact" : "Insufficient balance. Please contact our support team.",
    "voucherCouponTotal" : "Available Coupons",
    "voucherCouponTipGuide" : "Coupons can be used for payment after you select the payment channel.",
    "voucherPaytypeNotSupport" : "Coupons are unavailable for this payment channel",
    "voucherTipSideOne" : "Vouchers can be exchanged for all in-game packs and value-added services except the voucher itself.",
    "voucherTipSideTwo" : "Up to a 15% discount",
    "voucherYue" : "Balance",
    "jpUidLoginName" : "",
    "jpUidToken" : "",
    "jpUidInputToken" : "",
    "pnsBook" : "Survival Manual",
    "vipHeadText" : "VIP exclusive frame unlocked",
    "vipHeadGetText" : "Claim",
    "vipHeadGotText" : "Claimed",
    "vipHeadGetTitle" : "Confirm",
    "vipHeadGetTip" : "This reward can only be claimed once per account. Continue?",
    "vipHeadAwardText" : "Elite Commander (Permanent)",
    "vipHeadGetErrTip1" : "Failed. Please try again or contact CS.",
    "cartGuideTipNew" : "Add more items to use coupon",
    "newVipTitle" : "Top-Up Center VIP",
    "newVipLogin" : "LOG IN",
    "newVipNowPoint" : "Points:",
    "newVipNextLevel" : "\${point} points to next level",
    "newVipUpgrade" : "UPGRADE",
    "newVipLevel" : "VIP Privileges",
    "newVipTip" : "Coupons will be refreshed on 00:00 (UTC) every Saturday. You will receive them when you log in on the official top-up page.",
    "newVipWeekly" : "Weekly Gift",
    "newVipReachPoint" : "Requirements:",
    "newVipRuleInfo" : "Rules:",
    "pleaseLang" : "Choose a language",
    "reference" : "Order Number",
    "saveToNext" : "Save the credit card information.",
    "cardNum" : "Card Number",
    "expireTime" : "Valid Through",
    "CVV" : "CVV",
    "pleaseCard" : "Credit card type",
    "howToPay" : "How would you like to pay?",
    "checkCard" : "Please check the number of your card.",
    "checkExpiryDate" : "Please check the expiration date of your card.",
    "checkCVV" : "Please check the CVV of your card.",
    "addCard" : "New",
    "delete" : "Delete",
    "deleteCardTips" : "Delete saved credit card information?",
    "confirmDelete" : "Yes, delete",
    "cancelDelete" : "Cancel",
    "checkAllCardMsg" : "Please make sure you have entered the correct card number, expiration date and CVV.",
    "leaveCreditPageTips" : "The transaction will not be completed if you leave this page now. Still leave?",
    "sureToLeave" : "Leave",
    "continueToPay" : "Continue",
    "pushTest" : "Notification Test",
    "getNoticication" : "Not getting game notifications?",
    "waitCheckResult" : "Please wait for the test result.",
    "hadAbnormal" : "Anomaly that might lead to notification failure found.",
    "clickIntro" : "Tap the report to see solution",
    "networkCheck" : "Network test",
    "noticeAuthorityCheck" : "Notification access test",
    "noticeBtnCheck" : "Notification bar test",
    "gmsCheck" : "GMS service test",
    "batteryCheck" : "Battery optimization list test",
    "pushServiceCheck" : "Notification service test",
    "reCheck" : "Test Again",
    "noNoticeAuthorityTip" : "Notification access not granted on this device. Go to System Settings - Notifications to grant the game access.",
    "noNoticeBtnTip" : "Notification bar is turned off. Please turn it on in System Settings.",
    "noBatteryTip" : "The game is on battery optimization list, you might not get the notifications. Please go to System Settings - Battery - Battery Optimization to add the game to whitelist.",
    "noPushServiceTip" : "Notification server not connected. Tap [Connect] to resume the service.",
    "noNetworkTip" : "Your current network connection is unstable.",
    "noGmsTip" : "Your device does not support GMS. Please use a device that\'s compatible with GMS.",
    "pushConnectFail" : "Notification server disconnected.",
    "pushConnectSucc" : "Notification server connected.",
    "noGetPushTitle" : "If you still can\'t receive notification from the game. Please follow these steps:",
    "noGetPushContOne" : "1. Log out the game and then log in again on this device.",
    "noGetPushContTwo" : "2. Tap [Notification Test] to try to run a test. See if your device can receive any test notifications.",
    "noGetPushContThree" : "3. If you have received the test notification but still can\'t receive any other notifications, please log into the game, go to Settings - Notifications and check if all the notifications are turned on.",
    "noGetPushContFour" : "4. If you still can\'t receive any notifications, please contact our customer service.",
    "getPushSucc" : "Your device has received a test notification. The function is working normally!",
    "allCheckSucc" : "Notification test done. No anomaly is found!",
    "pushCheck" : "Notification test",
    "useDirectPay" : "Use Express Checkout",
    "paypalFraudnetInfo" : "Secure payment via PayPal",
    "goToSetting" : "Settings",
    "retry" : "Retry",
    "connect" : "Connect",
    "canRebind" : "You may bind again after unbinding",
    "agreePlatform" : "I have agreed to the \${service} and the \${privite}.",
    "sendGameNews" : "Subscribe to newsletters.",
    "canNotBindEmail" : "You will not be able to use this e-mail to log in once you have unbound it.",
    "canNotBindPhone" : "You will not be able to use this cellphone number to log in once you have unbound it.",
    "canChangeByEmail" : "You may log in with e-mail on different devices.",
    "canChangeByPhone" : "You may log in with cellphone number on different devices.",
    "loginSucc" : "Logged in",
    "phoneHadBind" : "The cellphone number has already been bound. Log in with it?",
    "emailHadBind" : "The email has already been bound. Log in with it?",
    "phoneNotBind" : "The cellphone number has not been bound yet. Create a new account?",
    "emailNotBind" : "The email has not been bound yet. Create a new account?",
    "emailAccount" : "E-mail Account",
    "phoneAccount" : "Cellphone Account",
    "phoneInputError" : "Invalid cellphone number",
    "registerNewAccount" : "Sign Up",
    "secureTip" : "Account Safety Tips",
    "toTop" : "Pin to top",
    "createNewWork" : "New Ticket",
    "serviceEvaluate" : "Rate Service",
    "emailRemind" : "Notifications",
    "isAgreeService" : "How do you like our service?",
    "thankEvaluateTop" : "Thank you for your feedback!",
    "inputValidEmail" : "Please enter a valid e-mail address.",
    "replyWillRemind" : "You will receive a notifying e-mail when your question is answered. Tap again to turn it off.",
    "isCancelEmailRemind" : "You will not receive any notifying e-mail. Still turn it off?",
    "reconfirmEmail" : "Please confirm your e-mail address.",
    "confirmCanSubmit" : "Confirm to submit the ticket",
    "serviceWillReply" : "You will be notified by e-mail when customer service has replied.",
    "cancelEmailRemind" : "Turn off [Notifications]?",
    "yes" : "Yes",
    "no" : "No",
    "inputWorkSearch" : "Search...",
    "loading" : "Loading",
    "loadingError" : "Failed to load. Please load again...",
    "noMore" : "Nothing more",
    "cancelToTop" : "Unpin",
    "evaluateOne" : "Very bad",
    "evaluateTwo" : "Bad",
    "evaluateThree" : "Neutral",
    "evaluateFour" : "Good",
    "evaluateFive" : "Very good",
    "confirmDelWorkTop" : "Delete this ticket?",
    "reRemindEmail" : "Need email notification? Just tap the [Notifications] button again.",
    "confirmWillReply" : "Confirm to agree to be notified by e-mail when customer service has replied.",
    "thankEvaluateBottom" : "",
    "confirmDelWorkBottom" : "A deleted ticket cannot be retrieved.",
    "morePurchaseWay" : "",
    "purchaseNeed" : "",
    "videoUploadSucc" : "Video uploaded",
    "videoUploadFail" : "Failed to upload video",
    "videoUploadLimit" : "Please upload an mp4 files with size below 400 MB and not longer than 2 minute.",
    "imageUploadSucc" : "Picture uploaded",
    "imageUploadFail" : "Failed to upload picture",
    "uploading" : "Uploading",
    "smartOrderCreate" : "Quick Ticket",
    "smartOrderSearch" : "Search",
    "smartOrderComing" : "Coming Soon",
    "smartOrderContactService" : "Customer Service",
    "smartOrderDetector" : "Assistant",
    "smartOrderDetect" : "Diagnose",
    "smartOrderDetecting" : "Diagnosing",
    "smartOrderDetectTip" : "An issue has been detected while you are playing the game. Please tap Diagnose so we can identify it.",
    "smartOrderDetectTip2" : "Issue identified. Please submit a ticket so we can solve it for you!",
    "smartOrderSubmit" : "Submit",
    "smartOrderIKnow" : "OK",
    "smartOrderConfirm" : "OK",
    "smartOrderLook" : "View",
    "smartOrderIsHelp" : "Was this article helpful?",
    "smartOrderInputQuestion" : "Write down the issue you have encountered.",
    "smartOrderPleaseInpt" : "Input",
    "smartOrderPleaseChoose" : "Select",
    "smartOrderStoreTime" : "Top-up Time",
    "smartOrderInputOrder" : "Please insert order number",
    "smartOrderInputPrice" : "Please insert order amount",
    "smartOrderNeedHelp" : "How may I help you?",
    "smartOrderLookHelpTip" : "You may check out the FAQ.",
    "smartOrderNoResult" : "No results. Please try another keyword.",
    "smartOrderUpdateTime" : "Last edit time",
    "smartOrderSelectStoreTime" : "Select Top-up time",
    "smartOrderAtlestChoose" : "Please at least fill in one",
    "pwaInstallAward" : "Add Shortcut",
    "getMasonry" : "Claim Diamond",
    "addToDrawerVisit" : "Add a shortcut so you can easily find it again.",
    "immeAddToGet" : "Add shortcut now to claim limited rewards.",
    "add" : "Add Shortcut",
    "talkNextTime" : "Later",
    "chooseRoleGetGift" : "Select your character to claim rewards",
    "getGiftSuccess" : "Claimed. Go check your rewards in the game.",
    "dmaTitle" : "Personalized Ads",
    "newAdd" : "New",
    "smartDelete" : "Delete",
    "wordLengthTip" : "(0-600 characters)",
    "areaLimitSwitchRegion" : "Switch Region",
    "areaLimitCurrentRegionCurrency" : "Current Region and Currency",
    "areaLimitRegion" : "Region:",
    "areaLimitCurrency" : "Currency:",
    "areaLimitNote" : "Note:",
    "areaLimitSwitchLimitation" : "Each account may switch region once every year.",
    "areaLimitPostSwitchCoupon" : "Once your region is switched, the currency of the new coupons will change accordingly.",
    "areaLimitRemainingSwitches" : "Switch attempts left: \${times}",
    "areaLimitNoRemainingSwitches" : "No switch attempts",
    "areaLimitUnableToSwitchThisYear" : "You may not switch region again this year.",
    "areaLimitCannotSwitch" : "Cannot Switch",
    "areaLimitNavigateToSwitch" : "Switch",
    "areaLimitConfirmSwitch" : "Confirm",
    "areaLimitPreSwitchRegionCurrency" : "Current Region and Currency",
    "areaLimitPostSwitchRegionCurrency" : "New Region and Currency",
    "areaLimitPostSwitchRestriction" : "Once done, you may not switch region again this year.",
    "areaLimitUnusedZBitWarning" : "You have unused Z-Bit that may not be used once you have switched region. Still proceed?",
    "areaLimitConfirm" : "Confirm",
    "areaLimitCancel" : "Cancel",
    "areaLimitInconsistencyWarning" : "Your access region is inconsistent with your payment region.",
    "areaLimitPromptToSwitch" : "Do you want to switch region?",
    "areaLimitEnterZipCode" : "*Please enter your zipcode",
    "areaLimitEnterInvalid" : "Zipcode is invalid, please re-enter",
    "areaLimitTaxRateTips" : "Depending on your location, the tax rate may vary, the payment amount shall prevail",
    "areaLimitInfoCollect" : "For information collection protection, please refer to the Privacy Policy",
    "getAward" : "Claim Reward",
    "selectProductTitle" : "Select Item",
    "hotSuggest" : "Hot",
    "inputKeywordSearch" : "Search...",
    "lookProductContent" : "Details",
    "popupClose" : "Close",
    "productSwitch" : "Switch",
    "confirmBuy" : "Buy",
    "thinkLater" : "Later",
    "areaLimitConfirmRegion" : "Confirm region",
    "areaLimitContinuePay" : "Continue to pay",
    "areaLimitSwitchLimitationTwice" : "Each account may switch region twice every year.",
    "dtmslgVipRule1" : "1. Available games: \${gameName}",
    "dtmslgVipRule2" : "Each type of event reward can only be claimed once.",
    "dtmslgVipRule3" : "2. VIP Points event: purchase item via our official page to earn points and get level coupons and weekly coupons.",
    "dtmslgVipRule4" : "3. The points you may earn might vary according to the currency you are using. For more details, please check the link at the bottom.",
    "dtmslgVipRule5" : "4. When using coupons, you will earn points based on the amount you\'ve paid after coupons are deducted.",
    "dtmslgVipRule6" : "5. The points you\'ve earned will expire in 365 days. This might affect your VIP level.",
    "dtmslgVipRule7" : "6. You will immediately receive a coupon for reaching a VIP level for the first time. The weekly coupon will be claimable at 00:00 (UTC+0) every Saturday.",
    "dtmslgVipRule8" : "7. You will need to log in to claim the weekly coupon. Don\'t miss out!",
    "dtmslgVipRule9" : "8. The currency of the coupon will be the currency of the last order you have made. Please contact our customer service if you wish to change the currency you are using.",
    "dtmslgVipRule10" : "9. See the table below for more details on the VIP levels and coupons.",
    "dtmslgVipRule11" : "10. In case of any dispute, the support team of Ant Legion has sole and final discretion of interpretation of these Terms and Conditions.",
    "dtmslgType10010" : "Daily Discount",
    "dtmslgType10020" : "Limited Offer",
    "dtmslgType10030" : "Hero",
    "dtmslgType10040" : "Gear",
    "dtmslgType10050" : "Rune Challenge",
    "dtmslgType10060" : "Totem",
    "dtmslgType10070" : "Holystone",
    "dtmslgType10080" : "Dragon",
    "dtmslgType10090" : "Resource",
    "dtmslgType10100" : "Build & Tech",
    "dtmslgType10110" : "Rare",
    "dtmslgType10120" : "Curio",
    "dtmslgType10130" : "Diamond",
    "dtmslgType10140" : "Voucher",
    "dtmslgType2" : "Event Pack",
    "dtmslgType3" : "Rewards Center",
    "dtmslgType4" : "Pop-Up Pack",
    "dtmslgType5" : "Main Screen Pack",
    "dtmslgType20010" : "Black Friday Pack",
    "dtmslgType20021" : "5-Day Gift",
    "dtmslgTypeother" : "Other",
    "rightsIntro" : "",
    "213RightsIntro": 'Due to a feature update, the "VIP Points" event will soon be discontinued.<br />\n  Please make sure to use the coupons obtained from the "VIP Points" event before they expire.<br />\n  End Time: 2024/08/19 08:00:00 (UTC)<br />\n  After the event ends, you can visit the Premium Membership Center to enjoy more benefits:<br />\n  Complete quests to earn points, which can be exchanged for coupons, in-game items, and other rewards! Enjoy exclusive member benefits and lucky draws.<br />\n  Stay tuned for more rewards and events!',
    "263RightsIntro": 'Due to a feature update, the "VIP Points" event will soon be discontinued.<br />\n  Please make sure to use the coupons obtained from the "VIP Points" event before they expire.<br />\n  End Time: 2024/09/28 00:00:00 (UTC)<br />\n  After the event ends, you can visit the Premium Membership Center to enjoy more benefits:<br />\n  Complete quests to earn points, which can be exchanged for coupons, in-game items, and other rewards! Enjoy exclusive member benefits and lucky draws.<br />\n  Stay tuned for more rewards and events!',
    "goToRights" : "Head to the Premium Member Center",
    "oldVipIntro" : "Please make sure to use the coupons obtained from the \"VIP Points\" event before they expire.",
    "pwa-20001" : "Please log in first",
    "pwa-20002" : "Parameter error",
    "pwa-20003" : "Please designate a character",
    "pwa-20004" : "Failed to send rewards. Please try again or contact Customer Support.",
    "pwa-20005" : "You have already claimed the reward.",
    "pwa-20100" : "The event hasn\'t started.",
    "pwa-20101" : "The event has ended.",
    "pwa-20102" : "You cannot claim the rewards yet.",
    "pwa-20103" : "Your rewards have expired.",
    "pwa-1001" : "Operation too frequent",
    "pwaCommon" : "Please try again later!",
    "zipCodeSwitchZipCode" : "Switch zipcode",
    "zipCodeState" : "state",
    "zipCodeRate" : "rate",
    "-" : "-",
    "officialStore": "Official Top-up Center",
    "headerSafeTip": "Safe and Risk-Free Instant Transaction",
    "safeChecking": "...scanning current payment environment",
    "safeChecked": "Secure, safe to use",
    "riskChecked": "Potential risk detected, proceed with caution",
    "footerSafeTitle1": "Safe",
    "footerSafeTitle2": "Convenient",
    "footerSafeTitle3": "Economic",
    "footerSafeTitle4": "Efficient",
    "footerSafeContent1": "Official Top-up Center",
    "footerSafeContent2": "Supports multiple payment methods",
    "footerSafeContent3": "Discount offers, more time-limited benefits",
    "footerSafeContent4": "Instant transaction, no delay",
    "limitedTimeActivityTitle" : "Time-Limited Benefits",
    "limitedTimeActivityTime" : "Event Duration:  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivityTaskProcess" : "(Currently \${curPay}/\${targetPay})",
    "limitedTimeActivityRateTips" : "(Exchange rates may vary, please refer to this page for accurate information)",
    "limitedTimeActivityNotAchieve" : "Not Completed",
    "limitedTimeActivityClaim" : "Claim",
    "limitedTimeActivityClaimed" : "Claimed",
    "limitedTimeActivityTimeLeft" : "Time-Limited: \${days}d \${hours}h \${minutes}m \${seconds}s",
    "limitedTimeActivityRecord" : "Claim Records",
    "limitedTimeActivityAward" : "Rewards",
    "limitedTimeActivityGotTime" : "Time Claimed",
    "limitedTimeActivityGotRole" : "Character Claimed",
    "limitedTimeActivityRule" : "Event Rules",
    "limitedTimeActivity285Rule1" : "1. Event Duration:  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivity285Rule2" : "2. During the event, complete time-limited tasks to claim rewards. Tasks are categorized into weekly and monthly tasks:",
    "limitedTimeActivity285Rule3" : "(1) Weekly Tasks: Each account is limited to completing one weekly task a week, resetting every Monday at 0:00.",
    "limitedTimeActivity285Rule4" : "Weekly Log in Task: Within the limited time, log in to the official website\'s top up page once.",
    "limitedTimeActivity285Rule5" : "Top up any amount: Within the limited time, top up any amount via the official website.",
    "limitedTimeActivity285Rule6" : "(2) Monthly Tasks: Each account is limited to one monthly task a month, resetting on the 1st of each month at 0:00.",
    "limitedTimeActivity285Rule7" : "Log in Task: Within the limited time, log in to the official website\'s top up page once.",
    "limitedTimeActivity285Rule8" : "Accumulative Top Up Task: Within the limited time, top up the required amount to claim a reward once.",
    "limitedTimeActivity285Rule9" : "Note: Due to the long duration of the event, exchange rates may fluctuate. Please refer to the displayed amount on the page for the top up amount.",
    "limitedTimeActivity285Rule10" : "3. Select a character before claiming a reward. You can find your rewards in-game after claiming them.",
    "limitedTimeActivityClaimAward" : "Claim Reward",
    "limitedTimeActivityConfirmGot" : "Confirm Claim",
    "limitedTimeActivityGetSucc" : "Claim Successful",
    "limitedTimeActivityGetFail" : "Claim Failed. Please try again later or contact customer service.",
    "limitedTimeActivityFrequent" : "Please avoid frequent actions.",
    "limitedTimeActivityLoginFirst" : "Please log in first.",
    "limitedTimeActivityWrongParam" : "Parameter Error",
    "limitedTimeActivityOverTips" : "The event has expired. Please refresh the page.",
    "preRightsIntro" : "Due to a feature update, the \"VIP Points\" event will soon be discontinued.<br />End Time: \${offLineDate}<br />Please make sure to use the coupons obtained from the \"VIP Points\" event before they expire.<br />After the event ends, you can visit the Premium Membership Center to enjoy more benefits:<br />Complete quests to earn points, which can be exchanged for coupons, in-game items, and other rewards! Enjoy exclusive member benefits and lucky draws.<br />Stay tuned for more rewards and events!",
    "riskTipTitle" : "Beware of Unlawful Behavior and Scams",
    "riskTipContent" : "Greetings, Players!\n\nWe have noticed that some players are engaging in actions that disrupt the game\'s order and fairness. Common violations include:\n\n1. Posting Unauthorized Ads: Sharing unauthorized ads through in-game chat or other channels, such as promoting illegal resource trading or unauthorized top-ups.\n2. Using Cheats or Scripts: Using cheats, scripts, or other technical means to obtain resources illegally.\n3. Unsolicited Invitations: Sending invitations through chat to lure players into contact through external channels (e.g., Line, Discord).\n4. Illegal Top Ups: Promoting unofficial top ups services with discounted prices to entice players.\n5. Other Scams: Engaging in fraudulent activities, such as impersonating official staff.\n\nWe urge all players to safeguard their personal information and assets. Do not trust any unlawful or scam-related messages. Engaging in any of the above activities carries significant risk, including the potential for account theft or involvement in fraudulent activities. Please note that we will not assist with losses incurred from illegal actions.\n\nWe will take appropriate action against accounts found to have engaged in any illegal activities based on the severity and impact of the violations. This may include, but are not limited to, official warnings, confiscation of illegal gains, temporary suspensions, or permanent bans. If you encounter any suspicious behavior in the game, please report it to our customer support team. We will investigate as soon as possible and take necessary measures. \n\nThank you for your understanding and support.",
    "linkValid": "The link has expired",
    "-" : "-",
    "accountLabel": "Account",
    "passwordLabel": "Password",
    "confirmPasswordLabel": "Confirm Password",
    "confirmDeleteTitle" : "Are you sure you want to delete your account and all characters?",
    "confirmDeleteYes" : "Yes. I want to delete my account and all characters.",
    "selectGame" : "Select Game",
    "confirmDeleteNo" : "No. I only want to delete a character. I would like to keep my account.",
    "delTermsTitle" : "Please read the account deletion requirements and notice carefully.",
    "delCondTitle" : "1. Account Deletion Requirements",
    "delCond1" : "(1) Please log in to your account before applying. If you can\'t log in, please [recover your account] first. Please make sure that the game account and character belong to you.",
    "delCond2" : "(2) Please confirm that your account and character have <span>no security risks</span>, including unresolved complaints, reports, investigations, arbitrations, or lawsuits (filed by or against you). \n",
    "delCond3" : "(3) Please confirm that your account and character have <span>no outstanding payments</span>, including unresolved refunds or active subscriptions.",
    "delNoticeTitle" : "2. Account Deletion Notice",
    "delNotice1" : "(1) The deletion of this game account and its associated characters will be <span>permanent and irreversible</span>.",
    "delNotice2" : "(2) Please <span>settle any outstanding in-game assets</span>, including but not limited to items, currency, and subscriptions, before proceeding, as these will be permanently deleted upon account deletion. No refunds will be issued after game server closure for deleted accounts or characters.",
    "delNotice3" : "(3) Account and character data deletion will also remove or anonymize all related information. However, you will have to manually unlink and manage data associated with third-party social media logins (e.g., Facebook).",
    "delNotice4" : "(4) A 14-day holding period (Cooling-off Period) is provided to protect your interest (except where local regulations differ), during which you can contact customer support to cancel the deletion request.",
    "delNotice5" : "(5) Upon successful submission, your account will be immediately frozen, but data deletion may take up to a week. You will receive an email notification upon completion.",
    "delFormConfirm1" : "I understand the conditions and consequences of account deletion.",
    "delFormConfirm2" : "This account has no outstanding reports or litigation.",
    "delForm" : "I have read and agree to the <a class=\"account-delete-link\" href=\"javascript:;\">Account Termination Agreement</a>",
    "cannotDeleteMsgTitle" : "Unable to delete account",
    "cannotDeleteMsg1" : "Your account does not meet the requirements for deletion:",
    "cannotDeleteMsg2" : "You have unresolved support tickets. Please resolve them before applying again.",
    "cannotDeleteMsg3" : "You have outstanding refunds. Please settle them before applying for account deletion.",
    "cannotDeleteMsg4" : "Your account is currently under review due to player reports or complaints. Please wait for the review to finish before applying again.",
    "formCompleted" : "Ticket Submitted",
    "formCheckMsg1" : "Your ticket has been submitted, please wait for review and reply.",
    "formCheckMsg2" : "You can check the ticket progress in <span class=\"account-delete-link\">[My Tickets]</span>.",
    "delEmailMsg1" : "Notify you by email after deletion?",
    "delEmailMsg2" : "Account deletion will take about a week due to data processing. Would you like an email notification upon completion?",
    "delEmailMsg3" : "Your email address will only be used for notification purposes.",
    "delEmailConfirmYes" : "Yes, please notify me via email.",
    "delEmailFill" : "Please enter your notification email address.",
    "delEmailConfirmNo" : "No, I don\'t need email notification.",
    "delCoolMsg1" : "Would you like a 14-day cooling-off period?",
    "delCoolMsg2" : "During the 14-day cooling-off period, your account will be frozen, but you can submit a request to cancel the deletion at any time. After 14 days, if you haven\'t cancelled, your account will be deleted and cannot be recovered.",
    "delCoolMsg3" : "If you choose not to have a cooling-off period, your account will be deleted immediately after the application is completed, and it cannot be recovered.",
    "delCoolConfirmYes" : "Yes, I want a 14-day cooling-off period.",
    "delCoolConfirmNo" : "No, delete it now.",
    "delSecondCheckMsg1" : "Are you sure you have handled all account contents and want to activate the account cooling-off period? Your account will be inaccessible after activation.",
    "delSecondCheckConfirmYes" : "Yes, activate it now.",
    "delResMsg1" : "Your account deletion request has been submitted, and the following account has been frozen:",
    "gameName" : "Game Name:",
    "gameAccount" : "Game Account:",
    "delResMsg2" : "<span>Please take a screenshot and save the above account information, as it\'s the only verification if you need to restore your account during the cooling-off period</span>.",
    "delResMsg3" : "Cooling-off period: 14 days. Remaining time:",
    "delResMsg4" : "To cancel the deletion request during the cooling-off period, click [Contact Support].",
    "copyAccountInfo" : "Copy account information",
    "delResMsg5" : "Your account deletion request has been processed, and your account is currently being deleted. Therefore, you can no longer log in to it.",
    "delResMsg6" : "Due to the large amount of data involved in deleting an account, it will take some time. Therefore, all traces of your account will not be erased immediately. We expect to complete this process within about a week.",
    "delResMsg7" : "If you have previously provided a notice email address, we will send an email to that address.",
    "delResMsg8" : "If you wish to log in to the game again, you may register a new account.",
    "appleOption" : "App Store",
    "googleOption" : "Google Play",
    "otherOption" : "Other channels",
    "itemWrong" : "There was an error with your input. Please try again.",
    "delRegisterTime" : "Registration Date",
    "delDevice" : "Frequently Used Device",
    "delIp" : "Frequently Used IP Address",
    "delHistoryPayChannel" : "Historical Recharge Channels",
    "delHistoryPayOrder" : "Past Order Numbers",
    "delDeleteReason" : "Reason for Account Deletion",
    "delPrevStep" : "Previous",
    "delNextStep" : "Next",
    "delSecondCheckMsg2" : "Are you sure you have handled all the account content and are now proceeding with account deletion? Once executed, your account will no longer be accessible.",
    "pleaseFillIn" : "Please provide the following information",
    "switchNewVersion": "Switch to New",
    "switchNewVersionPlatform": "Payment Platform",
    "updateVersionPopupContent": "To ensure smooth game performance and support for future new features, we recommend upgrading your device system for a more stable running experience and compatibility optimization.",
}